export default "__VITE_ASSET__CLsVzuuZ__"